import { EventEmitter, Inject, Output, Directive } from '@angular/core';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { FiDocumentTemplateItemOptionsColumnComponent } from './document-template-item-options-column.component';
import { FiReplaceLinkTypes } from '@fi-shared/fi-directives/replace-with-links/replace-with-links.directive';

@Directive()
export abstract class FiDocumentTemplateItemOptionsBase {
    @Output('mediaBankFileChanged') mediaBankFileChangedEmitter = new EventEmitter<any>();

    FiReplaceLinkTypes = FiReplaceLinkTypes;

    constructor(
        @Inject(FiDocumentTemplateItemOptionsColumnComponent) public data: FiDocumentTemplateItemOptionsColumnComponent,
        @Inject(TemplateLayoutLanguageService) public templateLayoutLanguageService: TemplateLayoutLanguageService,
    ) {
        this.mediaBankFileChangedEmitter.subscribe((value) => {
            data.mediaBankFileChangedEmitter.emit(value);
        });
    }
}
